module.exports = __webpack_public_path__ + "img/icon-star-quarter.8492487c.svg";